import { render, staticRenderFns } from "./IconProvider.vue?vue&type=template&id=22a45fb8"
import script from "./IconProvider.vue?vue&type=script&lang=js"
export * from "./IconProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports